import { useState } from "react";
import { CheckCircle2, ArrowRight, Star } from "lucide-react";

const pricingData = {
  ocr: {
    label: "Invoice OCR",
    tiers: [
      {
        name: "Free",
        price: "$0",
        period: "",
        badge: null,
        desc: "Try the platform — no card needed.",
        features: [
          "10 bonus credits on sign-up",
          "Raw OCR: 1 credit/page",
          "Field extraction: 3 credits/page",
          "Max 10 pages per call",
          "REST API access",
          "JSON response output",
        ],
        cta: "Try Free",
        link: "https://ocr.tyosolution.com",
        external: true,
        featured: false,
      },
      {
        name: "Starter",
        price: "$19",
        period: "",
        badge: null,
        desc: "For individuals and small teams.",
        features: [
          "1,000 credits (one-time)",
          "Raw OCR: 1 credit/page",
          "Field extraction: 3 credits/page",
          "Multi-page PDF support",
          "REST API access",
          "JSON output with confidence scores",
        ],
        cta: "Get Started",
        link: "https://ocr.tyosolution.com/dashboard?upgrade=1",
        external: true,
        featured: false,
      },
      {
        name: "Pro",
        price: "$45",
        period: "",
        badge: "Most Popular",
        desc: "For growing businesses.",
        features: [
          "5,000 credits (one-time)",
          "Raw OCR: 1 credit/page",
          "Field extraction: 3 credits/page",
          "Multi-page PDF support",
          "API analytics dashboard",
          "Priority support",
        ],
        cta: "Get Started",
        link: "https://ocr.tyosolution.com/dashboard?upgrade=1",
        external: true,
        featured: true,
      },
      {
        name: "Business",
        price: "$99",
        period: "",
        badge: null,
        desc: "For high-volume operations.",
        features: [
          "20,000 credits (one-time)",
          "Raw OCR: 1 credit/page",
          "Field extraction: 3 credits/page",
          "Multi-page PDF support",
          "Priority support",
          "Dedicated onboarding",
        ],
        cta: "Get Started",
        link: "https://ocr.tyosolution.com/dashboard?upgrade=1",
        external: true,
        featured: false,
      },
    ],
  },
  scoremycv: {
    label: "ScoreMyCV",
    tiers: [
      {
        name: "Free",
        price: "$0",
        period: "",
        badge: null,
        desc: "Try ATS scoring — no card needed.",
        features: [
          "3 free credits on sign-up",
          "Basic Analysis (ATS score + keywords)",
          "Skill gap + training links",
          "PDF & DOCX support",
        ],
        cta: "Try Free",
        link: "https://scoremycv.tyosolution.com",
        external: true,
        featured: false,
      },
      {
        name: "Starter",
        price: "$6",
        period: "",
        badge: null,
        desc: "For active job seekers.",
        features: [
          "20 credits (one-time)",
          "Basic Analysis — 1 credit",
          "Full Optimization — 3 credits",
          "PDF & DOCX support",
        ],
        cta: "Get Started",
        link: "https://scoremycv.tyosolution.com",
        external: true,
        featured: false,
      },
      {
        name: "Growth",
        price: "$19",
        period: "",
        badge: "Most Popular",
        desc: "For serious job seekers.",
        features: [
          "100 credits (one-time)",
          "Basic Analysis — 1 credit",
          "Full Optimization — 3 credits",
          "PDF & DOCX support",
          "Priority AI processing",
        ],
        cta: "Get Started",
        link: "https://scoremycv.tyosolution.com",
        external: true,
        featured: true,
      },
      {
        name: "Pro",
        price: "$45",
        period: "",
        badge: null,
        desc: "For power users.",
        features: [
          "500 credits (one-time)",
          "Basic Analysis — 1 credit",
          "Full Optimization — 3 credits",
          "PDF & DOCX support",
          "Priority AI processing",
        ],
        cta: "Get Started",
        link: "https://scoremycv.tyosolution.com",
        external: true,
        featured: false,
      },
    ],
  },
  pdfsplitter: {
    label: "PDF Splitter",
    tiers: [
      {
        name: "Free",
        price: "$0",
        period: "",
        badge: null,
        desc: "Try the API — no card needed.",
        features: [
          "20 one-time credits on sign-up",
          "1 credit = 1 split",
          "Max file size: 2 MB",
          "Max 10 outputs per split",
          "REST API access",
          "ZIP output",
        ],
        cta: "Try Free",
        link: "https://pdf-splitter.tyosolution.com",
        external: true,
        featured: false,
      },
      {
        name: "Starter",
        price: "$5",
        period: "",
        badge: null,
        desc: "100 credits. $0.05 each.",
        features: [
          "100 credits (never expire)",
          "Max file size: 50 MB",
          "Max 50 outputs per split",
          "REST API access",
          "ZIP output",
        ],
        cta: "Get Started",
        link: "https://pdf-splitter.tyosolution.com/dashboard",
        external: true,
        featured: false,
      },
      {
        name: "Pro",
        price: "$15",
        period: "",
        badge: "Most Popular",
        desc: "500 credits. $0.03 each.",
        features: [
          "500 credits (never expire)",
          "Max file size: 100 MB",
          "Max 100 outputs per split",
          "REST API access",
          "Priority support",
        ],
        cta: "Get Started",
        link: "https://pdf-splitter.tyosolution.com/dashboard",
        external: true,
        featured: true,
      },
      {
        name: "Business",
        price: "$40",
        period: "",
        badge: null,
        desc: "2,000 credits. $0.02 each.",
        features: [
          "2,000 credits (never expire)",
          "Max file size: 200 MB",
          "Max 200 outputs per split",
          "Dedicated onboarding",
          "Priority support",
        ],
        cta: "Get Started",
        link: "https://pdf-splitter.tyosolution.com/dashboard",
        external: true,
        featured: false,
      },
    ],
  },
  imgoptimizer: {
    label: "Image Optimizer",
    tiers: [
      {
        name: "Free",
        price: "$0",
        period: "",
        badge: null,
        desc: "Try the API — no card needed.",
        features: [
          "20 one-time credits on sign-up",
          "1 credit = 1 image processed",
          "Max file size: 5 MB",
          "Max 10 images per batch",
          "REST API access",
          "JSON response + image binary",
        ],
        cta: "Try Free",
        link: "https://img.tyosolution.com",
        external: true,
        featured: false,
      },
      {
        name: "Starter",
        price: "$5",
        period: "",
        badge: null,
        desc: "200 credits. $0.025 each.",
        features: [
          "200 credits (never expire)",
          "Max file size: 20 MB",
          "Max 50 images per batch",
          "REST API access",
          "WebP, JPEG, PNG output",
        ],
        cta: "Get Started",
        link: "https://img.tyosolution.com/dashboard",
        external: true,
        featured: false,
      },
      {
        name: "Pro",
        price: "$15",
        period: "",
        badge: "Most Popular",
        desc: "1,000 credits. $0.015 each.",
        features: [
          "1,000 credits (never expire)",
          "Max file size: 50 MB",
          "Max 100 images per batch",
          "REST API access",
          "Priority support",
        ],
        cta: "Get Started",
        link: "https://img.tyosolution.com/dashboard",
        external: true,
        featured: true,
      },
      {
        name: "Business",
        price: "$40",
        period: "",
        badge: null,
        desc: "5,000 credits. $0.008 each.",
        features: [
          "5,000 credits (never expire)",
          "Max file size: 100 MB",
          "Max 500 images per batch",
          "Dedicated onboarding",
          "Priority support",
        ],
        cta: "Get Started",
        link: "https://img.tyosolution.com/dashboard",
        external: true,
        featured: false,
      },
    ],
  },
  news: {
    label: "News Tracking",
    comingSoon: true,
    tiers: [
      {
        name: "Basic",
        price: "$19",
        period: "/month",
        badge: null,
        desc: "Stay informed with essentials.",
        features: ["5 tracked topics", "Daily digest", "Email alerts", "Core update alerts", "7-day history"],
        cta: "Join Waitlist",
        link: null,
        external: false,
        featured: false,
      },
      {
        name: "Pro",
        price: "$59",
        period: "/month",
        badge: "Most Popular",
        desc: "Real-time for professionals.",
        features: ["25 tracked topics", "Real-time alerts", "Slack integration", "Competitor tracking", "30-day history", "Sentiment analysis"],
        cta: "Join Waitlist",
        link: null,
        external: false,
        featured: true,
      },
      {
        name: "Enterprise",
        price: "Custom",
        period: "",
        badge: null,
        desc: "Full-scale intelligence platform.",
        features: ["Unlimited topics", "API access", "Custom integrations", "Dedicated analyst", "Unlimited history", "Custom reports"],
        cta: "Contact Us",
        link: null,
        external: false,
        featured: false,
      },
    ],
  },
};

export default function Pricing() {
  const [active, setActive] = useState("ocr");
  const scrollToContact = () =>
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });

  const activeData = pricingData[active];
  const tiers = activeData.tiers;

  return (
    <section id="pricing" className="py-24 md:py-32 px-6 md:px-10 section-dark relative" data-testid="pricing-section">
      <div className="absolute inset-0 grid-bg opacity-30" />
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-12">
          <span className="overline-tag block mb-3">Pricing</span>
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-4">
            Simple, transparent pricing.
          </h2>
          <p className="text-[#94A3B8] text-lg max-w-xl leading-relaxed">
            Start free. Scale as you grow. No hidden fees.
          </p>
        </div>

        {/* Service Tabs */}
        <div className="flex flex-wrap gap-2 mb-10">
          {Object.entries(pricingData).map(([key, s]) => (
            <button
              key={key}
              data-testid={`pricing-tab-${key}`}
              onClick={() => setActive(key)}
              className={`px-6 py-2.5 text-sm font-semibold rounded-xl border transition-all flex items-center gap-2 ${
                active === key
                  ? "bg-[#38BDF8] text-[#080f23] border-[#38BDF8] shadow-[0_0_20px_rgba(56,189,248,0.25)]"
                  : "border-white/[0.1] text-[#94A3B8] hover:text-white hover:border-white/25"
              }`}
            >
              {s.label}
              {s.comingSoon && (
                <span className={`text-[10px] font-semibold px-1.5 py-0.5 rounded ${
                  active === key ? "bg-[#080f23]/20 text-[#080f23]" : "bg-amber-400/15 text-amber-400"
                }`}>Soon</span>
              )}
            </button>
          ))}
        </div>

        {/* Coming Soon Banner */}
        {activeData.comingSoon && (
          <div className="mb-8 flex items-start gap-3 bg-amber-400/[0.07] border border-amber-400/25 rounded-xl px-5 py-4">
            <span className="text-amber-400 text-lg mt-0.5">🔔</span>
            <div>
              <p className="text-amber-300 font-semibold text-sm mb-0.5">This feature is currently in development.</p>
              <p className="text-[#94A3B8] text-sm">Pricing below is indicative. Join the waitlist and we'll notify you when it launches.</p>
            </div>
          </div>
        )}

        {/* Pricing Cards */}
        <div className={`grid grid-cols-1 gap-5 ${activeData.comingSoon ? "opacity-75" : ""} ${tiers.length === 4 ? "md:grid-cols-2 lg:grid-cols-4" : "md:grid-cols-3"}`}>
          {tiers.map((plan, i) => (
            <div
              key={plan.name}
              className={`relative flex flex-col rounded-2xl p-7 border transition-all ${
                plan.featured
                  ? "bg-[#38BDF8]/[0.06] border-[#38BDF8]/40 shadow-[0_0_40px_rgba(56,189,248,0.1)]"
                  : "bg-white/[0.03] border-white/[0.08] hover:border-white/[0.15]"
              }`}
              data-testid={`pricing-card-${i}`}
            >
              {plan.featured && (
                <div className="absolute top-0 left-0 right-0 h-0.5 rounded-t-2xl overflow-hidden">
                  <div className="trace-beam h-full" />
                </div>
              )}

              {plan.badge && (
                <div className="mb-4 flex items-center gap-1.5 w-fit bg-[#38BDF8]/15 border border-[#38BDF8]/30 text-[#38BDF8] text-xs font-semibold px-3 py-1 rounded-full">
                  <Star size={10} fill="#38BDF8" />
                  {plan.badge}
                </div>
              )}

              <div className="mb-6">
                <div className="text-xs font-semibold uppercase tracking-widest text-[#64748B] mb-2">{plan.name}</div>
                <div className="flex items-end gap-1 mb-2">
                  <span className="text-3xl font-bold text-white leading-none">{plan.price}</span>
                  {plan.period && <span className="text-[#64748B] text-sm mb-0.5">{plan.period}</span>}
                </div>
                <p className="text-[#94A3B8] text-sm leading-relaxed">{plan.desc}</p>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {plan.features.map(f => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <CheckCircle2 size={14} className="text-[#38BDF8] mt-0.5 shrink-0" />
                    <span className="text-[#94A3B8]">{f}</span>
                  </li>
                ))}
              </ul>

              {plan.external ? (
                <a
                  href={plan.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`pricing-cta-${i}`}
                  className={`w-full flex items-center justify-center gap-2 py-3.5 font-semibold text-sm rounded-xl transition-all group ${
                    plan.featured
                      ? "bg-[#38BDF8] text-[#080f23] hover:bg-[#0EA5E9] shadow-[0_0_20px_rgba(56,189,248,0.25)]"
                      : "bg-white/[0.06] text-white border border-white/[0.1] hover:bg-white/[0.1] hover:border-[#38BDF8]/40"
                  }`}
                >
                  {plan.cta}
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </a>
              ) : (
                <button
                  onClick={scrollToContact}
                  data-testid={`pricing-cta-${i}`}
                  className={`w-full flex items-center justify-center gap-2 py-3.5 font-semibold text-sm rounded-xl transition-all group ${
                    plan.featured
                      ? "bg-[#38BDF8] text-[#080f23] hover:bg-[#0EA5E9] shadow-[0_0_20px_rgba(56,189,248,0.25)]"
                      : "bg-white/[0.06] text-white border border-white/[0.1] hover:bg-white/[0.1] hover:border-[#38BDF8]/40"
                  }`}
                >
                  {plan.cta}
                  <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
                </button>
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-[#64748B] text-sm mt-8">
          {active === "ocr"
            ? "OCR credits never expire. Start free with 10 bonus credits on sign-up."
            : active === "scoremycv"
            ? "ATS scan credits never expire. Start free with 3 scans on sign-up."
            : active === "pdfsplitter"
            ? "PDF Splitter credits never expire. Start free with 20 credits on sign-up."
            : active === "imgoptimizer"
            ? "Image Optimizer credits never expire. Start free with 20 credits on sign-up."
            : "Track news and algorithm changes automatically. No setup required."}
        </p>
      </div>
    </section>
  );
}
